import {Alert, Button, Checkbox, Col, DatePicker, List, notification, Result, Row, TimePicker, Typography} from "antd";
import {DOCFLOW_HINTS} from "../../../../helpers/epd_astral.helper";
import React, {useEffect, useState} from "react";
import FieldBlock from "../../../field-block";
import moment from "moment/moment";
import localeDatePicker from "antd/lib/date-picker/locale/ru_RU";
import {epdAstralService} from "../../../../services";
import {createDetachedSignature, createHash} from "crypto-pro";
import i18n from "../../../../i18n";

export const DocFlowItem = ({item, certificate, attorney, setIsNeedUpdate}) => {
  const [dateFact, setDateFact] = useState(item.unload_time && moment(item.unload_time));
  const [timeFact, setTimeFact] = useState(item.unload_time && moment(item.unload_time));
  const [isCurrentDateTime, setCurrentDateTime] = useState(false);


  const [hash, setHash] = useState('');
  const [hashStatus, setHashStatus] = useState(i18n.t('modals.createSignature.hashStatus.1'));
  const [hashError, setHashError] = useState(null);
  const [signatureStatus, setSignatureStatus] = useState(i18n.t('modals.createSignature.signatureStatus.1'));
  const [signatureError, setSignatureError] = useState(null);

  const [data, setData] = useState(null);
  const [dataDoc, setDataDoc] = useState(null);
  const [signature, setSignature] = useState('');
  const [signatureDataDoc, setSignatureDataDoc] = useState('');
  const [nextTitle, setNextTitle] = useState(null);
  const [guid, setGuid] = useState(null);

  const [errorsInvalidFields, setErrorsInvalidFields] = useState({});

  const getFieldErrors = (nameField) => {
    return errorsInvalidFields &&
    typeof errorsInvalidFields[nameField] !== "undefined"
      ? errorsInvalidFields[nameField][0]
      : null;
  };

  async function createSignature(message, setSignature) {
    let hash;

    setSignature('');
    setSignatureError(null);

    setHash('');
    setHashError(null);
    setHashStatus(i18n.t('modals.createSignature.hashStatus.2'));

    try {
      hash = await createHash(message);

      setHash(hash);
      setHashStatus(i18n.t('modals.createSignature.hashStatus.3'));
    } catch (error) {
      setHashError(error.message);
      setHashStatus(i18n.t('modals.createSignature.hashStatus.1'));
      console.error(error);

      return;
    }

    setSignatureStatus(i18n.t('modals.createSignature.signatureStatus.2'));
    try {
      setSignature(await createDetachedSignature(certificate.thumbprint, hash));
      setSignatureStatus(i18n.t('modals.createSignature.signatureStatus.3'));
    } catch (error) {
      setSignatureError(error.message);
      setSignatureStatus(i18n.t('modals.createSignature.signatureStatus.1'));
    }
  }

  const setDefaultState = () => {
    setSignature('');
    setSignatureDataDoc('');
    setData(null);
    setDataDoc(null);
    setGuid(null);
    setNextTitle(null);
  }

  const requestQR = (guid) => {
    epdAstralService.requestQrCode({guid: guid})
      .then(res => {
        if (res.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.requestQrCode.success'),
            description: res.message,
          });
          setIsNeedUpdate(true);
        }
        if (res.status === 'error') {
          notification.error({
            message: i18n.t('components.notification.titles.requestQrCode.error'),
            description: res.message,
          });
        }
        setDefaultState();
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.requestQrCode.error'),
          description: err,
        });
        setDefaultState();
      });
  }

  const requestPrintForm = (guid) => {
    epdAstralService.requestPrintForm({guid: guid})
      .then(res => {
        if (res.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.requestPrintForm.success'),
            description: res.message,
          });
          setIsNeedUpdate(true);
        }
        if (res.status === 'error') {
          notification.error({
            message: i18n.t('components.notification.titles.requestPrintForm.error'),
            description: res.message,
          });
        }
        setDefaultState();
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.requestPrintForm.error'),
          description: err,
        });
        setDefaultState();
      });
  }

  const onClickDownload = (file) => {
    window.open(file);
  };

  const getXML = (guid, nextTitle) => {
    setNextTitle(nextTitle);
    setGuid(guid);
    epdAstralService.getXML({guid: guid, nextTitle: nextTitle})
      .then(resp => {
        setData(resp);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getXML'),
          description: err,
        });
      });
  }

  useEffect(() => {
    setHashError(null);
    setSignatureError(null);
  }, [certificate]);

  useEffect(() => {
    if (signatureError !==null || hashError !== null) {
      setDefaultState();
    }
  }, [signatureError, hashError]);

  useEffect(() => {
    if (isCurrentDateTime) {
      setDateFact(moment());
      setTimeFact(moment());
    }
  }, [isCurrentDateTime]);

  useEffect(() => {
    if (signature !== '') {
      const blob = new Blob([signature], {type: "application/x-pkcs7-signature"});
      const file = new File([blob], `sign-${guid}.p7s`, {type: blob.type, lastModified: Date.now()});

      epdAstralService.getTitle({
        guid: guid,
        nextTitle: nextTitle,
        signedDoc: file,
        dateFact: dateFact,
        timeFact: timeFact,
        attorney: attorney
      })
        .then(resp => {
          setDataDoc(resp);
          setSignature('')
        })
        .catch((err) => {
          notification.error({
            message: "getTitle",
            description: err,
          });
        });
    }
  }, [signature]);

  useEffect(() => {
    if (signatureDataDoc !== '' && dataDoc && dataDoc.data !== '') {
      const blob = new Blob([signatureDataDoc], {type: "application/x-pkcs7-signature"});
      const file = new File([blob], `sign-${guid}.p7s`, {type: blob.type, lastModified: Date.now()});

      const docBlob = new Blob([dataDoc.data], {type: "application/x-pkcs7-signature"});
      const doc = new File([docBlob], dataDoc.name, {type: blob.type, lastModified: Date.now()});

      epdAstralService.getSendDocument({filename: dataDoc.name, doc: doc, signature: file, t: nextTitle})
        .then(res => {
          if (res.status === 'success') {
            notification.success({
              message: i18n.t('components.notification.titles.getSendDocument.success'),
              description: res.message,
            });
            setIsNeedUpdate(true);
          }
          if (res.status === 'error') {
            notification.error({
              message: i18n.t('components.notification.titles.getSendDocument.error'),
              description: res.message,
            });
          }
          setDefaultState();
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getSendDocument.success'),
            description: err,
          });
          setDefaultState();
        });
    }
  }, [signatureDataDoc]);

  useEffect(() => {
    if (certificate && data && dataDoc === null) {
      createSignature(data.data, setSignature);
    }
    if (certificate && dataDoc) {
      createSignature(dataDoc.data, setSignatureDataDoc);
    }
  }, [data, dataDoc, certificate]);


  const buttons = [
    <>
      {item.docflow && item.docflow.nextTitle !== '' &&
        <div className='docflow-document-buttons-container'>
          <Typography.Title
            level={3}
            className='docflow-document-title'>{DOCFLOW_HINTS[item.docflow.type].button.toUpperCase()}
          </Typography.Title>
          <Button
            type="primary"
            className='docflow-document-button'
            onClick={() => {
              getXML(item.guid, item.docflow.nextTitle, item.id);
            }}
            disabled={certificate === null}
          >
            <span>{i18n.t('modals.docFlowItem.buttons.docflow')}</span>
          </Button>
        </div>
      }
      <span>{item.docflow && item.docflow.type && DOCFLOW_HINTS[item.docflow.type].hint}</span>
    </>
  ];

  if (item.docflow && item.docflow.type === 'CarrierInfoAcceptanceOfCargo') {
    if (item.qr_code) {
      buttons.push(
        <div>
          <img src={item.qr_code}></img>
        </div>
      );
    } else {
      buttons.push(
        <div>
          <span>{i18n.t('modals.docFlowItem.message')}</span>
        </div>
      )
    }
    buttons.push(<div><Button
      type="primary"
      style={{marginLeft: "auto"}}
      onClick={() => requestQR(item.epd_guid)}
    >
      <span>{i18n.t('modals.docFlowItem.buttons.request')}</span>
    </Button></div>);
  }

  if (item.docflow && item.docflow.type === 'CarrierInfoDeliveryOfCargo') {
    if (item.form_file) {
        buttons.push(
        <div><Button
          type="primary"
          style={{marginLeft: "auto"}}
          onClick={() => onClickDownload(item.form_file)}
        >
          <span>{i18n.t('modals.docFlowItem.buttons.printForm')}</span>
        </Button></div>
      );
    } else {
      buttons.push(
        <div>
          <span>{i18n.t('modals.docFlowItem.printFormMessage')}</span>
        </div>
      );
      buttons.push(<div><Button
        type="primary"
        style={{marginLeft: "auto"}}
        onClick={() => requestPrintForm(item.epd_guid)}
      >
        <span>{i18n.t('modals.docFlowItem.buttons.requestForm')}</span>
      </Button></div>);
    }
  }

  const lockedMess = <span>{i18n.t('modals.docFlowItem.lockedMess')}</span>

  return (
    <List.Item
      extra={item.locked ? lockedMess : buttons}
      style={{marginTop: "20px"}}
    >
      <List.Item.Meta
        description={
          <Row>
            <Col>{item.docflow && item.docflow.typeLabel}</Col>
          </Row>}
        title={item.point && item.point.address}
      />
      {
        (signatureError !== null || hashError !== null) &&
        <Alert
          type="error"
          message={i18n.t('modals.docFlowItem.error')}
          description={<>{hashError}<br/>{signatureError}</>}>
        </Alert>
      }
      {
        item.docflow && item.docflow.nextTitle === 4 &&
        <>
          <Row gutter={24}>
            <Col xs={24}>
              <span>{i18n.t('modals.docFlowItem.currentDate.label')}</span>
              <Checkbox
                style={{marginLeft: "10px"}}
                size="small"
                name="isCurrentDateTime"
                checked={isCurrentDateTime}
                onChange={(e) => {
                  setCurrentDateTime(!isCurrentDateTime);
                }}
              > {i18n.t('modals.docFlowItem.currentDate.title')}
              </Checkbox>
            </Col>
          </Row>

          <FieldBlock title="" name="SdfsF" getErrors={getFieldErrors}>
            <Row gutter={24}>
              <Col xs={12}>
                <DatePicker
                  // defaultValue={item.unload_time ? moment(item.unload_time) : null}
                  style={{width: "100%"}}
                  className={'ant-date-picker-no-bg'}
                  locale={localeDatePicker}
                  value={dateFact}
                  onChange={(d) => {
                    if (d) {
                      setDateFact(d);
                      setCurrentDateTime(false);
                    }
                  }}
                />
              </Col>
              <Col xs={12}>
                <TimePicker
                  // defaultValue={item.unload_time ? moment(item.unload_time) : null}
                  style={{width: "100%"}}
                  format="HH:mm"
                  placeholder={i18n.t('modals.docFlowItem.time.placeholder')}
                  value={timeFact}
                  onChange={(t) => {
                    if (t) {
                      setTimeFact(t);
                      setCurrentDateTime(false);
                    }
                  }}
                />
              </Col>
            </Row>
          </FieldBlock>
        </>
      }
    </List.Item>
  )
}
